import React from 'react';
// Helpers
//import { getGlobalCssVariables } from '../../../helpers/general';

interface INgDpHorzIcon extends React.HTMLProps<SVGElement> {
    className?: string;
    fill?: string;
    onClick?: (event: React.MouseEvent<SVGSVGElement, MouseEvent>) => void;
}

const NgDpHorzIcon = (props: INgDpHorzIcon) => {
    const fillColor = props.fill || '#003348';
    return (
        <svg
            viewBox="900 400 900 600"
            height="40"
            width="120"
            id="svg2"
            version="1.1"
            className={props.className || ''}
            xmlns="http://www.w3.org/2000/svg"
        >
            <g transform="matrix(1.3333333,0,0,-1.3333333,0,1440)" id="g10">
                <g id="g12">
                    <g id="g14">
                        <g transform="translate(843.1089,640.0015)" id="g20">
                            <path
                                id="path22"
                                fill="#d3d4cd"
                                fillOpacity={1}
                                fillRule="nonzero"
                                stroke="none"
                                d="m 0,0 c -33.688,0 -61,27.311 -61,61 0,0.042 0.004,0.085 0.004,0.128 H -508.59 V -257.666 H 9.38 l 5.809,3.392 V 1.908 C 10.333,0.663 5.244,0 0,0"
                            />
                        </g>
                        <g transform="translate(334.5186,381.7402)" id="g24">
                            <path
                                id="path26"
                                fill="#003348"
                                fillOpacity={1}
                                fillRule="nonzero"
                                stroke="none"
                                d="M 0,0 H 518.053 L 523.854,3.393 0,317.134 Z"
                            />
                        </g>
                        <g transform="translate(843.1089,640.0015)" id="g28">
                            <path
                                id="path30"
                                fill="#006098"
                                fillOpacity={1}
                                fillRule="nonzero"
                                stroke="none"
                                d="M 0,0 C -18.744,0 -35.505,8.461 -46.695,21.765 L -246.663,-97.998 15.265,-254.869 V 1.926 C 10.386,0.669 5.271,0 0,0"
                            />
                        </g>
                        <g transform="translate(904.1079,701.001)" id="g32">
                            <path
                                id="path34"
                                fill="#ff3156"
                                fillOpacity={1}
                                fillRule="nonzero"
                                stroke="none"
                                d="m 0,0 c 0,-33.689 -27.31,-61 -60.999,-61 -33.689,0 -60.999,27.311 -60.999,61 0,33.689 27.31,60.999 60.999,60.999 C -27.31,60.999 0,33.689 0,0"
                            />
                        </g>
                        <g transform="translate(1042.2197,627.9541)" id="g36">
                            <path
                                id="path38"
                                fill={fillColor}
                                fillOpacity={1}
                                fillRule="nonzero"
                                stroke="none"
                                d="m 0,0 c 0,18.861 -10.796,31.394 -27.051,31.394 h -18.612 v -62.787 h 18.612 C -10.796,-31.393 0,-18.861 0,0 m 18.24,0 c 0,-27.547 -18.116,-45.911 -45.291,-45.911 h -36.108 v 91.822 h 36.108 C 0.124,45.911 18.24,27.547 18.24,0"
                            />
                        </g>
                        <path
                            id="path40"
                            fill={fillColor}
                            fillOpacity={1}
                            fillRule="nonzero"
                            stroke="none"
                            d="m 1086.77,673.865 h 17.496 v -91.822 h -17.496 z"
                        />
                        <g transform="translate(1223.1387,627.9541)" id="g42">
                            <path
                                id="path44"
                                fill={fillColor}
                                fillOpacity={1}
                                fillRule="nonzero"
                                stroke="none"
                                d="m 0,0 c 0,-28.291 -17.62,-47.152 -45.291,-47.152 -28.415,0 -47.276,18.861 -47.276,47.152 0,28.292 18.613,47.152 47.276,47.152 13.153,0 23.948,-3.35 32.51,-10.174 L -24.32,26.058 c -4.84,4.467 -11.664,6.576 -20.723,6.576 -17.62,0 -29.408,-13.029 -29.408,-32.634 0,-19.605 11.664,-32.634 29.284,-32.634 15.263,0 25.313,9.43 26.803,23.948 h -23.7 V 5.832 H -0.248 C -0.124,3.847 0,1.985 0,0"
                            />
                        </g>
                        <path
                            id="path46"
                            fill={fillColor}
                            fillOpacity={1}
                            fillRule="nonzero"
                            stroke="none"
                            d="m 1247.214,673.865 h 17.496 v -91.822 h -17.496 z"
                        />
                        <g transform="translate(1360.876,659.3477)" id="g48">
                            <path
                                id="path50"
                                fill={fillColor}
                                fillOpacity={1}
                                fillRule="nonzero"
                                stroke="none"
                                d="M 0,0 H -28.043 V -77.305 H -45.539 V 0 H -73.458 V 14.518 H 0 Z"
                            />
                        </g>
                        <g transform="translate(1425.7764,614.8013)" id="g52">
                            <path
                                id="path54"
                                fill={fillColor}
                                fillOpacity={1}
                                fillRule="nonzero"
                                stroke="none"
                                d="M 0,0 -15.262,37.35 -30.524,0 Z M 5.832,-14.518 H -36.48 l -7.446,-18.24 h -18.736 l 39.211,91.822 h 16.255 l 39.21,-91.822 H 13.277 Z"
                            />
                        </g>
                        <g transform="translate(1536.4639,596.561)" id="g56">
                            <path
                                id="path58"
                                fill={fillColor}
                                fillOpacity={1}
                                fillRule="nonzero"
                                stroke="none"
                                d="m 0,0 v -14.518 h -58.072 v 91.822 h 17.496 l 0,-77.304 z"
                            />
                        </g>
                        <g transform="translate(1030.4316,477.0186)" id="g60">
                            <path
                                id="path62"
                                fill={fillColor}
                                fillOpacity={1}
                                fillRule="nonzero"
                                stroke="none"
                                d="m 0,0 c 0,9.431 -6.329,15.759 -16.007,15.759 h -17.868 v -31.518 h 17.868 C -6.08,-15.759 0,-9.431 0,0 m 17.992,0.62 c 0,-18.488 -13.029,-30.896 -32.759,-30.896 h -19.108 v -31.27 h -17.496 v 91.822 h 37.225 c 19.357,0 32.138,-11.912 32.138,-29.656"
                            />
                        </g>
                        <g transform="translate(1145.46,461.3838)" id="g64">
                            <path
                                id="path66"
                                fill={fillColor}
                                fillOpacity={1}
                                fillRule="nonzero"
                                stroke="none"
                                d="m 0,0 c 0,19.605 -12.036,32.634 -30.028,32.634 -17.993,0 -30.153,-13.029 -30.153,-32.634 0,-19.605 12.16,-32.634 30.153,-32.634 C -12.036,-32.634 0,-19.605 0,0 m -78.298,0 c 0,28.292 19.358,47.152 48.27,47.152 28.787,0 48.144,-18.86 48.144,-47.152 0,-28.291 -19.357,-47.152 -48.144,-47.152 -28.912,0 -48.27,18.861 -48.27,47.152"
                            />
                        </g>
                        <g transform="translate(1186.1631,425.7715)" id="g68">
                            <path
                                id="path70"
                                fill={fillColor}
                                fillOpacity={1}
                                fillRule="nonzero"
                                stroke="none"
                                d="m 0,0 6.576,11.788 c 7.818,-6.452 16.503,-8.809 24.942,-8.809 11.539,0 18.24,3.97 18.24,11.042 0,7.446 -7.694,10.672 -19.234,13.898 l -5.212,1.489 c -15.137,4.095 -26.429,10.423 -26.429,25.438 0,16.751 13.525,27.919 33.999,27.919 11.788,0 22.211,-3.475 31.021,-10.548 l -7.817,-12.16 c -6.824,5.46 -14.146,8.189 -23.08,8.189 -9.679,0 -16.007,-4.094 -16.007,-10.547 0,-7.32 7.321,-9.927 16.38,-12.532 l 5.335,-1.489 C 52.859,39.831 67.874,32.138 67.874,15.635 67.874,-0.62 53.729,-11.54 32.634,-11.54 19.978,-11.54 8.189,-7.569 0,0"
                            />
                        </g>
                        <g transform="translate(1342.8848,492.7773)" id="g72">
                            <path
                                id="path74"
                                fill={fillColor}
                                fillOpacity={1}
                                fillRule="nonzero"
                                stroke="none"
                                d="M 0,0 H -28.043 V -77.305 H -45.539 V 0 H -73.458 V 14.518 H 0 Z"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default NgDpHorzIcon;
